import { StrictMode } from "react";
import { Capacitor } from '@capacitor/core';
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import config, { validateConfig } from "./config";
import { initSentry } from "./lib/sentry";
import { initWebVitals } from "./utils/analytics";

// Initialize Sentry FIRST (before React) to catch all errors
initSentry();

// Initialize Web Vitals tracking
initWebVitals();

// Validate configuration on app startup
if (config.app.isProduction) {
  try {
    validateConfig();
  } catch (error) {
    console.error('Configuration validation failed:', error);
  }
}

// Initialize Google Analytics if tracking ID is provided
if (config.analytics.gaTrackingId && config.analytics.enabled) {
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${config.analytics.gaTrackingId}`;
  document.head.appendChild(script);

  script.onload = () => {
    window.gtag?.('config', config.analytics.gaTrackingId);
  };
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);

// Register service worker for PWA installability and offline support
// Disable service worker on native Capacitor platforms where it's unsupported
if ('serviceWorker' in navigator && !Capacitor.isNativePlatform()) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.warn('Service worker registration failed', err);
      });
  });
}
